module.exports = __webpack_public_path__ + "img/family-mb.26301b7e.webp";